import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const TimeoutPopup = new PopupBuilder('Timeout', {
  incident_id: Basketball3x3IncidentId.Timeout,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
